/* eslint-disable */

import React, { Component } from 'react'
import { Dimensions, Platform, Alert, StyleSheet, Text, View, Linking } from 'react-native'
import moment from 'moment'
import _ from 'lodash'
import { Fonts } from '../Themes'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scrollview'
import { KargoeConfig } from '../Config/AppConfig'
//import Toast from 'react-native-root-toast';
import { LayoutProvider } from 'recyclerlistview';
import { MEDIA_TYPE, VIEW_MODE, POST_TYPE, CURRENCY_SHORTCODES } from '../Constant/index'
//import RNFetchBlob from 'react-native-fetch-blob';
import { Image } from 'react-native'
import Marker from 'react-native-image-marker'
//import Autolink from 'react-native-autolink'
//import SafariView from '../Lib/SafariView/'
//import * as RNLocalize from "react-native-localize"
import I18n from 'i18n-js'
import { CURRENCY_SELECTOR } from '../Constant/index'
import Images from "../Themes/Images"

const ViewTypes = {
  GRID_LEFT: -1,
  GRID_MIDDLE: -2,
  GRID_RIGHT: -3,
  SINGLE_LANDSCAPE: 3,
  SINGLE_SQUARE: 4,
  SINGLE_PORTRAIT: 5,
}
export const PEOPLE = 0
export const MUSIC = 1
export const MYSHOP = 2
export const ENDORSE = 3
export const DONATATION = 4
export const LOCATION = 5
export const NOHASHTAG = 'Processing...'
export const base64Jpeg = `data:image/jpeg;base64,`
export const INVITED = "invited!"
export const INVITING = "inviting!"
export const SENT = "sent"
export const INTVITE = "invite!"
const { width, height } = Dimensions.get("window")
const screenWidth = width
const itemWidth = (width - 0) / 3
const itemHeight = itemWidth
const GRID_MODE = 'grid'
const SINGLE_MODE = 'list'

const SINGLE_EXTRA_GAP = 80

const MIN_PULLDOWN_DISTANCE = -100;
export const getFbAvatar = (id) => {
  if (!isBlank(id)) {
    return `https://graph.facebook.com/${id}/picture?type=normal`
  }
  return null
}
export const generateKey = (pre) => {
  return `${pre}${new Date().getTime()}`;
}
export const generateISellID = (pre) => {
  return Math.random().toString(36).substr(2, 6);
}
isNumeric = (s) => {
  return !isNaN(s - parseFloat(s));
}
checkDouble = (price) => {
  if (isNumeric(price))
    return '$' + parseFloat(price).toFixed(2)
  else
    return 'n/a'
}
/* reference from post wallb base:
var optionEditPost = [
  I18n.t('editpost.title'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'), I18n.t('editpost.delete')
]

var optionRepost = [
  I18n.t('editpost.repost'), I18n.t('editpost.messageKargoe'), I18n.t('editpost.sendDirect'), I18n.t('editpost.share'), I18n.t('editpost.report')
]
*/
export const optionType = {
  EDIT: I18n.t('editpost.title'),
	COPY_LINK: I18n.t('editpost.copyLink'),
  SEND_DIRECT: I18n.t('editpost.sendDirect'),
  SHARE: I18n.t('editpost.share'),
  DELETE: I18n.t('editpost.delete'),
  REPOST: I18n.t('editpost.repost'),
  MESSAGE_KARGOER: I18n.t('editpost.messageKargoe'),
  REPORT: I18n.t('editpost.report'),
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  INSTAGRAM: 'instagram',
  TUMBLR: 'tumblr',

}
// recompute in case lang setting has changed
export const optionTypeDynamic = ( ) => {
  let otype = {
    EDIT: I18n.t('editpost.title'),
		COPY_LINK: I18n.t('editpost.copyLink'),
    SEND_DIRECT: I18n.t('editpost.sendDirect'),
    SHARE: I18n.t('editpost.share'),
    DELETE: I18n.t('editpost.delete'),
    REPOST: I18n.t('editpost.repost'),
    MESSAGE_KARGOER: I18n.t('editpost.messageKargoe'),
    REPORT: I18n.t('editpost.report'),
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    TUMBLR: 'tumblr',
  }
  return otype
}
export const downloadImageToBase64 = async (url) => {

  /*
  return await RNFetchBlob.config({
    fileCache: true
  })
    .fetch("GET", url)
    // the image is now dowloaded to device's storage
    .then(resp => {
      // the image path you can use it directly with Image component

      return resp.readFile("base64");
    })
    .then(base64Data => {

      return base64Data
    });
  */

}

const b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
export const stob = ( string ) => {
  var output = ''
  for( var block = 0, charCode, i = 0, map = b64chars ;
      string.charAt( i | 0 ) || (map = '=', i % 1);
      output += map.charAt(63 & block >> 8 - i % 1 * 8) ) {

    charCode = string.charCodeAt( i += 3/4 )
    if( charCode > 0xFF ) return false
    block = block << 8 | charCode
  } return output
}
export const btos = ( b64 ) => {
  let str = b64.replace(/=+$/, '')
  var output = ''
  if( str.length % 4 == 1 ) return false
  for( var bc = 0, bs = 0, buffer, i = 0;
        buffer = str.charAt(i++);
        ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4)?
          output += String.fromCharCode(255 & bs >> (-2 * bc & 6)):
          0 )
    buffer = b64chars.indexOf(buffer)

  return output
}
export const ToB64 = ( string ) => {
  let percentEncoded = encodeURIComponent ( string )
    , utf8 = percentEncoded.replace
            ( /%([0-9A-F]{2})/g
            , ( m, hex ) => String.fromCharCode(`0x${hex}`) )
  return stob( utf8 ) // return base64 looking string "wa08woefhawoehf=="
}
export const FromB64 = ( b64 ) => {
  const toPercent = ( char ) => '%'+('00'+char.charCodeAt(0).toString(16)).slice(-2)
  let ascii = btos( b64 )
    , percent = ascii.split('').map(toPercent).join('')
  return decodeURIComponent ( percent )
}

export const clearCache = ( filename ) => {
  //RNFetchBlob.fs.unlink( `${RNFetchBlob.fs.dirs.CacheDir}/${filename}` )
}

export const SaveToCache = ( filename, data ) => {
  let chunkSize = 1024 // bytes
    , encoded = ToB64 ( data )
    //, debugDecoded = FromB64(encoded)
    //, equal = data == debugDecoded
  console.tron.log(`Offline SaveToCache filename: ${filename}`)
  // console.tron.display({name: 'Offline', preview: "SaveToCache", value: {equal: data == debugDecoded, data: data, encoded: encoded, debugDecoded: debugDecoded}})
  return new Promise( (resolve, reject) => {
    // Touch the file, resetting it if it exists.
    if (false)
    RNFetchBlob.fs.createFile( `${RNFetchBlob.fs.dirs.CacheDir}/${filename}`, '', 'utf8' )
    .then(( ) => {// Get a file handle for writing, with append disabled (write from the beginning)
        RNFetchBlob.fs.writeStream( `${RNFetchBlob.fs.dirs.CacheDir}/${filename}`, 'utf8', false )
        .then( oStream => {
          let pieces = Math.ceil( encoded.length / chunkSize )
          // Write data out to cache file in 1KB chunks
          for( var i = 0 ; i < pieces ; ++ i ) {
            let start = i * chunkSize, end = ((i+1)*chunkSize)
              , chunk = encoded.slice( start, end )
            oStream.write ( chunk )
          }
          resolve( oStream.length )
          console.tron.log(`Offline SaveToCache filename: ${filename}, complete`)
          return oStream.close( )
        }).catch( (err) => {
          console.log('lib/utils - Error opening stream handle [fs.writeStream]')
          reject(JSON.stringify(err))
        })
    }).catch( (err) => {
      console.log('lib/utils - Save to Cache error [fs.createFile]')
      reject(JSON.stringify(err))
    })
  })
}
export const ReadFromCache = ( filename ) => {
  console.tron.log(`Offline ReadFromCache filename: ${filename}`)
  return new Promise( (resolve, reject) => {
    if (false)
    RNFetchBlob.fs.readStream( `${RNFetchBlob.fs.dirs.CacheDir}/${filename}`, 'utf8' )
    .then( iStream => {
      var data = ''
      iStream.open( )
      iStream.onData( chunk => data += chunk )
      iStream.onError( err => {
        console.log('lib/utils - iStream error')
        console.log(JSON.stringify(err))
        reject(err)
      })
      iStream.onEnd( ( ) => {
        console.tron.log(`Offline ReadFromCache filename: ${filename}, complete`)
        resolve(FromB64(data))
      } )
    }).catch( err => {
      console.log('lib/utils - Error opening file stream for reading [fs.readStream]')
      console.log(JSON.stringify(err))
      reject(err)
    })
  })
}

export const optionShare = [
  `facebook`, `twitter`, /*`tumblr`,*/ `instagram`

]
export const optionEditPost = [
  `edit`, `send direct`, `share`, `delete`

]
export const optionRepost = [
  `repost`, `message kargoer`, `send direct`, `share`, `report`

]

export const optionReport = {
  0: "Sexual content or nudity",
  100: "Violence or profanity",
  200: "Hateful",
  300: "Illegal product or service",
  400: "Infringes on my rights",
  500: "Dangerous acts",
  600: "Other"

}
export const convertToPercent = (coor, widthScreen, heightScreen) => {
  const xP = ((coor.x / widthScreen) * 100).toFixed(3)
  const yP = ((coor.y / heightScreen) * 100).toFixed(3)
  return {
    xPercent: xP,
    yPercent: yP
  }
}
export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
}
export const checkPrice = (PriceMin, PriceMax) => {
  const priceMinFinal = checkDouble(PriceMin)
  const priceMaxFinal = checkDouble(PriceMax)
  if (PriceMin == PriceMax) {
    return `${priceMinFinal}`
  } else {
    return `${priceMinFinal}` + " " + '-' + " " + `${priceMaxFinal}`
  }
}
export const alertView = (title = "", message = "", callback = null) => {
  Alert.alert(
    title,
    message,
    [
      { text: 'OK', onPress: callback },
    ]
  )
}
export const isBlank = (str) => {
  return (!str || /^\s*$/.test(str));
}
export const layoutProvider = (viewMode, dataProvider) => {
  let layoutProvider = new LayoutProvider(
    index => {
      if (viewMode == GRID_MODE) {
        if (index % 3 === 0) {
          return ViewTypes.GRID_LEFT
        } else if (index % 3 === 1) {
          return ViewTypes.GRID_MIDDLE
        } else {
          return ViewTypes.GRID_RIGHT
        }
      }
      else {
        // Single mode, should use index and aspect ratio
        // return ViewTypes.SINGLE_LANDSCAPE // *** TODO - just return aspect ratio as the type ***
        return 1.0 * dataProvider._data[index]['AspectRatio']
      }
    },
    (type, dim) => {
      switch (type) {
        case ViewTypes.GRID_LEFT:
          dim.width = itemWidth
          dim.height = itemWidth
          break
        case ViewTypes.GRID_MIDDLE:
          dim.width = itemWidth
          dim.height = itemWidth
          break
        case ViewTypes.GRID_RIGHT:
          dim.width = itemWidth
          dim.height = itemWidth
          break
        case ViewTypes.SINGLE_LANDSCAPE:
        case ViewTypes.SINGLE_SQUARE:
        case ViewTypes.SINGLE_PORTRAIT:
          // might use these ViewTypes, but for now use aspect ratio in default...
          dim.width = screenWidth
          dim.height = screenWidth + SINGLE_EXTRA_GAP
          break;
        default:
          dim.width = screenWidth
          dim.height = Math.round(screenWidth / type) + SINGLE_EXTRA_GAP // aspect ratio
      }
    }
  )
  return layoutProvider
}
export const isURL = (str) => {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
    '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return pattern.test(str);
}

export const isIPhone5s = () => {
  const dimensions = Dimensions.get('window')
  return (
    Platform.OS === 'ios' &&
    !Platform.isPad &&
    !Platform.isTVOS &&
    (dimensions.height === 568 || dimensions.width === 320)   /* 5s or SE */
  )
}

export const isIPhoneX = () => {
  const dimensions = Dimensions.get('window')

  // https://ios-resolution.com
  return (
    Platform.OS === 'ios' &&
    !Platform.isPad &&
    !Platform.isTVOS &&
    (dimensions.height === 812 || dimensions.width === 812 || /* X XS */
     dimensions.height === 896 || dimensions.width === 896 ||
     dimensions.height === 844 || dimensions.width === 844 || // 12 && 12 pro
     dimensions.height === 780 || dimensions.width === 780 || // 12 mini
     dimensions.height === 926 || dimensions.width === 926    // 12 pro max
     )   /* XR XSMax*/
  )
}

export const ifIPhoneX = (iPhoneXStyle, otherStyle) => {
  if (isIPhoneX()) {
    return iPhoneXStyle
  }

  return otherStyle
}
const regexBio = (code, Bio, j) => {

  var found = code.match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);


  if (found) {

    var pattern = /\B@[a-z0-9_-]+/gi;

    return found[0].match(pattern)
  }
  return ' ';
}
generateKeyID = (pre) => {
  return `${pre}${new Date().getTime()}`;
}
bBToLink = ({code,  j,navigation, numLines = 1},callback) => {
  var found = code.match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);


  var valid = ["post", "profile"];
  if (found) {

    if (found[1] === "post") {
      return (<Text key={this.generateKeyID(j)} style={[styles.link, styles.wrap]} onPress={() => { }} >{found[4]}</Text>);
    } else if (found[1] === "profile") {
      var newFound = (found[4] + "]").match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/)


      return (<Text numberOfLines={numLines} key={/*this.*/generateKeyID(j)} style={[styles.link, styles.wrap, {color: '#888888'} ]}
        onPress={() => {
					console.log(`bBToLink text press profile`)

          navigation.navigate('profilewallv2', {
            userId: newFound ? newFound[2] : found[2],
            username: newFound ? newFound[4] : found[4]
          })
          callback()
        }

        }>{newFound ? (newFound[4] !== ']' ? newFound[4] : "") : found[4]}</Text>);
    }
  }
  return false;
}

// if it exists, replace the reply substring string w/ nothing
// see also PostViewComponent also defined there, later commonize this
replaceEncodedReplyString = (string) => {
  const ENCODED_REPLY_PATTERN             = '^reply to .link profile [A-Za-z0-9]+ none @.+. from [0-9]+.[0-9]+:'
  let r = new RegExp(ENCODED_REPLY_PATTERN)
  if (string)
    return string.replace(r, '') 
  else 
    return string
}

replaceAudioStringWithNote = (string) => {
  const AUDIO_PATTERN_TO_END = '.*audioComment https:.*$' // see also PostViewComponent
  let r = new RegExp(AUDIO_PATTERN_TO_END)
  return string.replace(r, 'Voice note 〜') 
}

// leaving title aka docname at end
replacePDFStringWithNote = (string) => {
  const PDF_PATTERN_TO_END = '.*PDF Attachment https:.* __DOCNAME__ ' // see also PostViewComponent
  let r = new RegExp(PDF_PATTERN_TO_END)
  return string.replace(r, 'PDF 📄 ') 
}

export const convertMessage = ({item,styles,numLines,navigation},callback) => {

  let itemIn = item // string, so regular copy should do

  // replicate from PostViewComponent for now
  // first strip off our encoded reply stuff which is at beginning;
  // however, we may want to leave some of it on later like the 'reply to @name'
  item = /*this.*/replaceEncodedReplyString(itemIn)
  item = /*this.*/replaceAudioStringWithNote(item)
  item = /*this.*/replacePDFStringWithNote(item)

  let isVoiceNote = (item.indexOf('Voice note 〜') == 0)

  if (isVoiceNote) item = item.replace(' 〜', ' ')

  let voiceNoteImage = isVoiceNote ? (<Image 
    style={[{ top: 7, width:23, height:17 }, 
            { transform: [{ translateY: 5 }] }  ] } source={Images.audioWave1}/>) : null

  // no good need to look at style more
  let voiceNoteImage2 = isVoiceNote ? (<Image 
    style={[{ top: 7, width:23, height:17 }, 
            { transform: [{ translateY: 5}] , transform: [{translateX: 23}] } ] } source={Images.audioWave1}/>) : null

	if (item.indexOf('@') < 0) {
    //console.info("convertMessage return 1 item = "  + item)
		return (
			<Text style={{...styles.wrap, fontFamily: Fonts.style.font.regular}}>
				{item}
        {( Platform.OS != 'web' ) ? voiceNoteImage : null}
			</Text>)
	}
  var parts = item.split(/(\[[^]*?\])/);
  for (var i = 0; i < parts.length; ++i) {

    var href = /*this.*/bBToLink({
     code: parts[i],
     j: i ,
     navigation,
     numLines
    },callback);


    if (href) {
      parts[i] = href
    } else {

      parts[i] = parts[i].replace('\]', " ")
      parts[i] = (<Text key={i} style={[styles.text, styles.wrap, {fontFamily: Fonts.style.font.regular}]} text={parts[i]}
                            onPress={(link, match) => {
                                if (match) {
                                  const type = match.getType() // email, hashtag, phone, twitter, or url
                                  //alert("custom link handler type = " + type)
                                  if (type === 'url') /*SafariView*/Linking.openUrl(link) // internal to app web view
                                  else Linking.openURL(link)
                                }
                               }
                             }
                  >{parts[i]}</Text>);

    }
	}
	if (numLines) {
    //console.info("convertMessage return 2")
		return (
			<Text numberOfLines={numLines} style={[styles.wrap, {fontFamily: Fonts.style.font.regular}]}>
				{parts.map((item, i) => (parts[i]))}
			</Text>)
  }
	else { //console.info("convertMessage return 3") // not seeing this one
		return (
			<>
				{parts.map((item, i) => (parts[i]))}
			</>
		)
  }
/*
		return (
			<Text style={[styles.wrap]}>
				{parts.map((item, i) => (parts[i]))}
			</Text>)
*/			
}

// Flatten any of the BB code forms i.e. [link type ID cssClass ...restString] --> "...restString"
export const BBCodesToPlainText = ( string ) => {

  if( typeof string !== 'string' ) return ''

  const simplify = (BBCode) => {
    var found = BBCode.match(/\[([a-zA-Z]+) ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);
    return found? found[5]: false // in this context [5] is the "...rest" string (.*)
  }

  var parts = string.split(/(\[[^]*?\])/)
  if( parts.length == 1 ) return string

  for (var i = 0; i < parts.length; ++i) {
    var plainText = simplify(parts[i])
    if(plainText) parts[i] = plainText
  }

  return parts.join(' ')
}

export const convertBio = (Bio) => {



  var parts = Bio.split(/(\[[^]*?\])/);
  if (parts.length == 1) {
    return Bio
  }
  for (var i = 0; i < parts.length; ++i) {
    var href = regexBio(parts[i], Bio, i);
    if (href) {
      if (href == parts[i - 1]) {
        parts[i] = ''
      } else {
        parts[i] = href
      }
    } else {
      var pattern = /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g

      //let regexPart = parts[i].replace(/[^a-z0-9]/gi, ' ');
      if (!parts[i].match(pattern)) {
        let regexPart = parts[i].replace(pattern, ' ');
        parts[i] = regexPart
      }


    }
  }

  return parts.join(' ')
}
export const binarySearch = (d, t, s, e) => {

  const m = Math.floor((s + e) / 2);
  if (t == Math.round(Number(d[m].TimeStamp))) { return d[m] }
  if (e - 1 === s) {
    return Math.abs(Math.round(Number(d[s].TimeStamp))) - Math.round(Number(t)) > Math.abs(Math.round(Number(d[e].TimeStamp)) - Math.round(Number(t))) ? d[e] : d[s]
  }


  if (t > Math.round(Number(d[m].TimeStamp))) { return binarySearch(d, t, m, e) }
  if (t < Math.round(Number(d[m].TimeStamp))) {
    return binarySearch(d, t, s, m)
  }
}
sliptTime = (timePassed) => {
  var newTime = timePassed.split(' ')


  switch (newTime[1]) {

    case 'days':
      newTime[1] = 'd'
      break;
    case 'day':
      newTime[1] = 'd'
      newTime[0] = '1'
      break;
    case 'months':
      newTime[1] = 'm'
      break;
    case 'month':
      newTime[1] = 'm'
      newTime[0] = '1'
      break;
    case 'years':
      newTime[1] = 'y'
      break;
    case 'year':
      newTime[1] = 'y'
      newTime[0] = '1'

      break;
    default:
      break;
  }
  return newTime.join('')
}
lessThan1Day = (date) => {
  return moment(date).isAfter(moment().subtract(24, 'hours'));
}
export const getTimeStamp = () => {
  var now = new Date();
  return ((now.getMonth() + 1) + '/' + (now.getDate()) + '/' + now.getFullYear() + " " + now.getHours() + ':'
    + ((now.getMinutes() < 10) ? ("0" + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ("0" + now
      .getSeconds()) : (now.getSeconds())));
}
export const convertTimeDay = (unixTime) => {
  var date = new Date(unixTime * 1000);
  return moment(date).format("MM/DD/YY")
}
export const OrderTime = unixTime => {
  var date = new Date(unixTime * 1000)
  return moment(date).format('MMM D, YYYY')
}
export const convertTime_UNUSED = (unixTime) => {

  var date = new Date(unixTime * 1000);
  var dayWrapper = moment(date);
  const now = moment()

  const diff = dayWrapper.diff(now, null, true);
  const diffDuration = moment.duration(diff);
  if (this.lessThan1Day(date)) {
    var hourMinutest = String(Math.abs(diffDuration.hours())) + "h" + " " + String(Math.abs(diffDuration.minutes())) + "m"
    if (Math.abs(diffDuration.minutes()) != 0 && Math.abs(diffDuration.hours()) != 0) {
      return hourMinutest
    }
    if (Math.abs(diffDuration.hours()) == 0) {
      return Math.abs(diffDuration.minutes()) + "m"
    }

    return String(Math.abs(diffDuration.hours())) + "h"

  }
  var timePassed = moment(dayWrapper.toString()).fromNow(true);


  return this.sliptTime(timePassed)
}



// faster, 1.9K vs 64K+, based upon https://github.com/melvinsembrano/date-diff/blob/master/src/date-diff.coffee
// implied -> now, then
class DateDiff {
  constructor(date1, date2) {
    this.divisors = {
      days: 1000 * 60 * 60 * 24,
      hours: 1000 * 60 * 60,
      minutes: 1000 * 60,
      seconds: 1000
    }
    this.date1 = date1
    this.date2 = date2
    this.difference = Math.floor(this.date1 - this.date2)
  }

  weeks() {
    return this.days() / 7
  }

  days() {
    return this.difference / this.divisors.days
  }

  hours() {
    return this.difference / this.divisors.hours
  }

  minutes() {
    return this.difference / this.divisors.minutes
  }

  seconds() {
    return this.difference / this.divisors.seconds
  }

  months() {
    return Math.floor(this.difference / (1000 * 60 * 60 * 24 * 30.42))
  }

  years() {
    return Math.floor(this.difference / (1000 * 60 * 60 * 24 * 365.25))
  }

  endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0)
  }

  endOfYear(date) {
    return new Date(date.getFullYear() + 1, 0, 0)
  }
}

export const convertTime = (unixTime) => {
  const past = new Date(unixTime * 1000)
  const now = new Date()
  const dateDiff = new DateDiff(now, past)
  const years = dateDiff.years()
  if (years >= 1)
    return Math.floor(years) + 'y'
/*
	const months = dateDiff.months()
  if (months >= 1)
		return Math.floor(months) + 'm'
*/
  const weeks = dateDiff.weeks()
  if (weeks >= 1)
    return Math.floor(weeks) + 'w'
  const days = dateDiff.days()
  if (days >= 1)
    return Math.floor(days) + 'd'
  const hours = dateDiff.hours()
  if (hours >= 1)
    return Math.floor(hours) + 'h'
  const minutes = dateDiff.minutes()
  if (minutes > 1)
    return Math.floor(minutes) + 'm'
  return 'now'
}

export { KeyboardAwareScrollView }

/*
* Get avatar of user
*/
export const getAvatar = (userId) => {
  if (userId == null) {
    return ``
  }
  return `${KargoeConfig.baseUrlMedia}/${userId}-avatar.jpg`
}
export const convertPercentToPoint = (item, hScale, vScale) => {
  return {
    left: (item.Left * hScale),
    top: item.Top * vScale,
  }
}
/*
* Get uri of image (thumb)
*/
export const getUri = (postId, version) => {
  if (postId == null)
    return ``
	if (version)
		return `${KargoeConfig.baseUrlMedia}/${postId}-thumb.jpg?${version}`
	return `${KargoeConfig.baseUrlMedia}/${postId}-thumb.jpg`
}

export const getUriNothumb = (postId, version) => {
  if (postId == null)
    return ``
	if (version)
		return `${KargoeConfig.baseUrlMedia}/${postId}.jpg?${version}`
  return `${KargoeConfig.baseUrlMedia}/${postId}.jpg`
}

export const getUriVideo = (postId, version) => {
  if (postId == null)
    return ``
 return `${KargoeConfig.baseUrlMedia}/${postId}.mp4`
}

export const getCharityUri = (charityId) => {
  if (charityId == null)
    return ``
  return `${KargoeConfig.baseUrlMedia}/${charityId}-charity.jpg`
}

//---------------------------------------------------------------------------------------------
// Show error with Toast
//---------------------------------------------------------------------------------------------
export const showError = (error) => {
  if (error) {
    console.error(error);
  }
  /*
  // Add a Toast on screen.
  let toast = Toast.show(error && error.message ? error.message : "Unknow error", {
    duration: Toast.durations.SHORT,
    position: Toast.positions.CENTER,
    shadow: true,
    animation: true,
    hideOnPress: true,
    delay: 0,
    onShow: () => {
      // calls on toast\`s appear animation start
    },
    onShown: () => {
      // calls on toast\`s appear animation end.
    },
    onHide: () => {
      // calls on toast\`s hide animation start.
    },
    onHidden: () => {
      // calls on toast\`s hide animation end.
    }
  });

  // You can manually hide the Toast, or it will automatically disappear after a `duration` ms timeout.
  setTimeout(function () {
    Toast.hide(toast);
  }, 3000);

  */
}


//---------------------------------------------------------------------------------------------
// Post
//---------------------------------------------------------------------------------------------
export const isSelling = (post) => {
  if (!post) return false

  if (post && post.Selling) {
    return post.Selling
  }
  return false
}
export const isVideo = (post) => {
  if (!post) return false

  const data = post

  if (data.MediaType == MEDIA_TYPE.MP4) {
    return true
  }

  if (data.Type != POST_TYPE.LINKED && data.Type != POST_TYPE.VIDEO_LINKED) return false

  if (data.Type == POST_TYPE.VIDEO_LINKED && typeof (data.MiniMeta) == 'string') {
    if (data.Meta) {
      return true
    }
  }

  return false
}

export const isLink = (post) => {
  if (!post) return false

  const data = post

  if (data.Type == POST_TYPE.LINKED || data.Type == POST_TYPE.VIDEO_LINKED) return true
  return false
}

export const isYouTube = (post) => {
  if (!post) return false
  const data = post

  if (typeof (data.MiniMeta) == 'string') {
    if (data.Meta) {
      return true
    }
  }
  return false
}

const styles = StyleSheet.create({


  link: {
    color: Fonts.style.baseColor,
    fontFamily: Fonts.style.font.bold,
  },
  wrap: {
    flexGrow: 1,
    flex: 0.8, flexWrap: 'wrap'
  },

  textBold: {
    color: Fonts.style.color.baseColor,
    fontFamily: Fonts.style.font.bold,
    fontSize: 14
  },
  text: {
    color: Fonts.style.color.baseColor,
    fontFamily: Fonts.style.font.light,
    fontSize: 14
  },

})

//Google map get location from address
export const getLocationFromAddress = (address) => {
  return new Promise((resolve, reject) => {
    const options = {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
    fetch(`${KargoeConfig.googleMaps.geocodingUrl}&address=${address}`, options)
      .then(res => res.json())
      .then(res => {
        let result = res.results[0]
        if (result) {
          return resolve(result)
        } else {
          return reject()
        }

      })
      .catch(error => {
        return reject()
      })
  });

}
export const getPlaces = (location, radius, type, calledFrom = '') => {
  console.tron.log(`getPlaces location: ` + JSON.stringify(location) + `, radius: ${radius}, type: ${type}, calledFrom: ${calledFrom}`)
  return new Promise((resolve, reject) => {
    const options = {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
    fetch(`${KargoeConfig.googleMaps.placeUrl}&location=${location}&radius=${radius}&type=${type}`, options)
      .then(res => res.json())
      .then(res => {
        console.tron.display({
          name: `googleMaps.placeUrl`,
          preview: ``,
          value: {
            state: res
          }
        })

        let results = res.results
        if (results.length > 0) {
          return resolve(results)
        } else {
          return reject()
        }

      })
      .catch(error => {
        return reject()
      })
  });

}

export const isShoppableItemId = (itemId) => {
  return typeof itemId == 'string' && itemId.length > 5 && itemId.substr(-5) == '_shop'
}

export const shoppableProductToKargoeItem = (merchants, product) => {
  // const imageUrls = product.image.length > 0 ? [product.image[0]] : []
  let imageUrls = ''
  if (typeof product.image == 'object')
    imageUrls = product.image.length > 0 ? [product.image[0]] : []
  if (typeof product.image == 'string')
    imageUrls = [product.image]
  let   endorserPct = 0
  let   shoppableMerchantId = product.merchant_id ? product.merchant_id : null
  for (let i = 0; i < merchants.length; i++)
    if (merchants[i]['id'] == shoppableMerchantId || merchants[i]['name'] == product.merchant) {
      shoppableMerchantId = merchants[i]['id']
      endorserPct = parseFloat(merchants[i]['endorserCutPct']).toFixed(2)
    }
  var minPrice, maxPrice
  /*const*/ maxPrice = parseFloat(product.price).toFixed(2)
  if(typeof product.price === 'number')
    minPrice = maxPrice = product.price
  else if(typeof product.price === 'string')
    minPrice = maxPrice = parseFloat(product.price).toFixed(2)
  const minCut = (minPrice * endorserPct / 100).toFixed(2)
  const maxCut = (maxPrice * endorserPct / 100).toFixed(2)
  const kargoeItem = {
    "ItemId": `${product.part_number}_shop`,
    "Brand": product.brand,
    "Category": "",
    "Description": product.description,
    "ImageUrls": imageUrls,
    "ThumbUrls": [
    ],
    "Options": '', // "Small Medium Large Red Blue",
    "PriceMax": maxPrice, // retail_price, sale_price
    "PriceMin": minPrice,
    "Tags": [
    ],
    "Title": product.name,
    "StoreId": null,
    "State": 1,
    "NumVariants": 1, // unknown
    "Availability": 1,
    "Codes": [
    ],
    "StoreName": product.merchant,
    "SellerKind": null, // "sk3",
    "ExtStoreItemId": "",
    "PlatformDeleted": false,
    "EndorserPct": endorserPct,
    "Cut": {
      "Pct": endorserPct,
      "Min": minCut,
      "Max": maxCut
    },
    "StoreReturnPolicy": null,
    "Shoppable": {
      "MerchantId": shoppableMerchantId
    }
  }
  // console.tron.display({ name: `convert`, preview: `shoppableProductToKargoeItem`, value: { product: product, kargoeItem: kargoeItem } })
  return kargoeItem
} // shoppableProductToKargoeItem

export const humanReadableSpace = (value) => {
  if (typeof value != 'number')
    return value
  if (value > 1099511627776)
    return (value / 1099511627776).toFixed(2) + " TB (" + value + ")"
  if (value > 1073741824)
    return (value / 1073741824).toFixed(2) + " GB (" + value + ")"
  if (value > 1048576)
    return (value / 1048576).toFixed(2) + " MB (" + value + ")"
  if (value > 1024)
    return (value / 1024).toFixed(2) + " KB (" + value + ")"
  return value
}

export const humanReadableNumber = (value) => {
  if (typeof value != 'number')
    return value
  if (value > 1000000000)
    return (value / 1000000000).toFixed(1) + "B"
  if (value > 1000000)
    return (value / 1000000).toFixed(1) + "M"
  if (value > 1000)
    return (value / 1000).toFixed(1) + "K"
  return value
}

export const initScreenDepth = (screenThis, args) => {
  screenThis.state.visible = true
  screenThis.state.topScreen = true
  screenThis.state.nearTopScreen = true
  screenThis.screenNavKey = args.navigation.state.key
  screenThis.screenRouteName = args.navigation.state.routeName
}

export const calcScreenDepthState = (currentState, navStack, screenKey) => {
  let stackDepth = 10
  let routeName = ''
  for (let i = navStack.length-1, depth = 0; i >= 0; i--, depth++)
    if (navStack[i].key == screenKey) {
      routeName = navStack[i].routeName
      stackDepth = depth
      // console.tron.log(`calcScreenDepthState found, routeName: ${routeName}, i: ${i}, depth: ${depth}`)
      break
    }
  let stateChanges = {
    visible: stackDepth < 2, // deprecated
    topScreen: stackDepth == 0, // obvious, fully draw
    nearTopScreen: stackDepth < 2, // draw stuff so it looks normal, ie: draw videos as an image
  }
  const changed = currentState.topScreen != stateChanges.topScreen || currentState.nearTopScreen != stateChanges.nearTopScreen
  // if (changed) console.tron.log(`calcScreenDepthState route: ${routeName} stackDepth: ${stackDepth} changes: ` + JSON.stringify(stateChanges))
  return  changed ? stateChanges: null
}

export const objectEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export const objectDeepCopy = (obj) => {
  if (!obj) return obj // parse pukes on undefinded and so does callers sometimes
  // console.log("objectDeepCopy JSON.stringify result = " + JSON.stringify(obj, null, 2))
  return JSON.parse(JSON.stringify(obj))
}

export const parseQRCode = (qrcode) => {
  let OfferId  = null
	let VendorId = null
	let ItemId   = null
	if (typeof qrcode == 'string') {
		const parts = qrcode.split('-')
		if (parts.length > 1 && parts[0].substr(0,6) == 'kargoe') {
			if (parts.length == 3 && parts[0] == 'kargoeo')
				OfferId = qrcode.substr(8)
			if (parts.length == 2 && parts[0] == 'kargoev')
				VendorId = qrcode.substr(8)
			else
				console.tron.log(`unrecognized kargoe qr code ${qrcode}`)
		}
		else if (qrcode)
			ItemId = qrcode
	}
	const result = {
		ItemId,
		OfferId,
		VendorId,
	}
	console.tron.log(`parseQRCode ${qrcode} becomes ` + JSON.stringify(result))
	return result
}

// used within Sagas

export const responseToChanges = (title, response) => {
  console.tron.display({name: responseToChanges, preview: title, value: {response}})
  const apiResponse = typeof response.data != 'undefined' ? response.data : null
  const errorMessage = apiResponse && typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['detail'] : "Unknown"
  const result = {
    phase: 'error',
    error: {
      httpCode: response.status, // response.respInfo.status
      code:     apiResponse && typeof apiResponse.errors != 'undefined' ? apiResponse.errors[0]['code'] : -1,
      title:    title,
      detail:   errorMessage,
    },
    logRef:   apiResponse && typeof apiResponse.logRef != 'undefined' ? apiResponse.logRef : null,
    modified: Date.now()
  }
  return result
}

export const exceptionToChanges = (title, error) => {
  console.tron.display({name: 'exceptionToChanges', preview: title, value: {error}})
  const result = {
    phase: 'error',
    error: {
      httpCode:  null,
      code:      -1,
      title:     title,
      detail:    error.message,
      exception: error,
    },
    logRef:    null,
    modified: Date.now()
  }
  return result
}

export const getDeviceCurrency = () => {
  let acceptedCurrencies = []
  for (let entry of CURRENCY_SELECTOR)
    acceptedCurrencies.push(entry['Id'])
  const localCurrencies = ['USD'] // RNLocalize.getCurrencies()
  let userCurrency = null
  for (let currency of localCurrencies)
    if (acceptedCurrencies.indexOf(currency) >= 0) {
      userCurrency = currency
      break
    }
  if (userCurrency == null)
    userCurrency = 'USD'
  return userCurrency
}

export const i18nCurrency = (amount, currency, options = {}) => {
  const { extended = false } = options
  console.tron.log(`i18nCurrency amount: ${amount}, currency: ${currency}, extended: ${extended}`)
  const symbol = typeof CURRENCY_SHORTCODES[currency] != 'undefined' ? CURRENCY_SHORTCODES[currency] : '$'
  // let price = (+amount).toFixed(2)
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
  let decimalPlaces = typeof options.integer == 'undefined' ? 2 : 0
  let price = (+amount).toLocaleString(undefined, {minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces})
  let result = ''
  if (extended)
    switch (currency) {
      default: result = `${currency} ${symbol}${price}` // TODO: left or right with symbol
    }
  else
    switch (currency) {
      default: result = `${symbol}${price}`
    }
  return result
}

export const i18nCurrencyDuo = (amount1, amount2, currency, options = {}) => {
  const identical = amount1 == amount2
  if (identical)
    return i18nCurrency(amount1, currency, options)
  // let price1 = (+amount1).toFixed(2)
  // let price2 = (+amount2).toFixed(2)
  let price1 = (+amount1).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
  let price2 = (+amount2).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
  const { extended = false } = options
  const symbol = typeof CURRENCY_SHORTCODES[currency] != 'undefined' ? CURRENCY_SHORTCODES[currency] : '$'
  let result = ''
  if (extended)
    switch (currency) {
      default: result = `${currency} ${symbol}${price1}-${price2}` // TODO: left or right with symbol
    }
  else
    switch (currency) {
      default: result = `${symbol}${price}-${price2}`
    }
  return result
}

export const localPrice = (price, currency, rates, userCurrency, convert = true) => {
  if (!currency)
    currency = 'USD'
  if (!userCurrency)
    userCurrency = 'USD'
  let symbol = typeof CURRENCY_SHORTCODES[userCurrency] != 'undefined' ? CURRENCY_SHORTCODES[userCurrency] : '$'
  if (!rates) 
    return {
      price,
      currency,
      formatted: '',
    }
  if (price == 0) {
    const formattedPrice = (+price).toFixed(2)
    const formatted = `${userCurrency} ${symbol}${formattedPrice}`
    return {
      price,
      currency: userCurrency,
      formatted,
    }
  }
  if (!convert) {
    symbol = typeof CURRENCY_SHORTCODES[currency] != 'undefined' ? CURRENCY_SHORTCODES[currency] : '$'
    const origPrice = (+price).toFixed(2)
    const origFormatted = `${currency} ${symbol}${origPrice}`
    return {
      price,
      currency,
      formatted: origFormatted,
    }
  }
  const different = currency != userCurrency
  const conversion = different ? rates[currency] / rates[userCurrency] : 1
  const paypalForexCharge = different ? 0.035 : 0 // between 3 and 4 percent with lots of variables...
  const newPriceEstimate = (price / conversion * (1 + paypalForexCharge)).toFixed(2)
  const formatted = `${userCurrency} ${symbol}${newPriceEstimate}`
  // `\$${parseFloat(postTag.Amount).toFixed(2)}`
  return {
    price: 0 + newPriceEstimate,
    currency: userCurrency,
    formatted,
  }
}

// if you are not logged in, which language?

export const getDeviceLanguage = () => {
  let code = 'en'
  const locales = null // RNLocalize.getLocales();
  if (Array.isArray(locales))
    code = locales[0].languageCode.substr(0, 2)
  return code
}

export const closestKargoeRatio = (initialAspect) => {
  let finalAspect = initialAspect
  const square = Math.abs(initialAspect - 1)
  const threeQuarters = Math.abs(initialAspect - 0.75)
  const fourThirds = Math.abs(initialAspect - 1.333)
  if (square < threeQuarters && square < fourThirds)
    finalAspect = 1
  else if (threeQuarters < square && threeQuarters < fourThirds)
    finalAspect = 0.75
  else
    finalAspect = 1.333
  return finalAspect
}

  // if defined, call afterMarkingFn after image is marked (e.g. typically this is a share)
  // to be called with url of marked image
  // if pathNotUrl is true, send resulting image as a file path not a file url to the afterMarkingFn
  // charity struct like this:
  // charity = {"CharityId":"ALn1fYb5pQPeA7","PaypalEmail":"endorser@kargoe.com","CharityName":"ziggy charity","ImageUrl":"https://s3.amazonaws.com/kargoe2-dev/ALn1fYb5pQPeA7-charity.jpg"}
  // note:  last 2 args hideTags hideLogo are normally false if not present e.g. neither tags nor logo will be hidden by default
  export const markImageWithWatermark = ( inputImageUri, afterMarkingFn, pathNotUrl, charity /*optional*/, hideTags, hideLogo ) => {
    console.log("in mark image with watermark uri = " + inputImageUri)
    console.log("in mark image with watermark charity = " + charity)
    Image.getSize(inputImageUri, (mainImageW, mainImageH) => {
      console.log("ready to call markIt with " + mainImageW + " " + mainImageH)
      markIt(mainImageW, mainImageH)
    })

    function markIt(mainw, mainh) {
      const markerWidth = 1242
      const markerHeight = 122
      const markerScale = mainw/markerWidth // should scale marker by this after it is read in
      // *** this marks the logo
      // to preserve callback pyramid, just use a blank logo if logo is not to be shared
      Marker.markImage({
          src: inputImageUri,
          markerSrc: hideLogo ? require('../Images/spacer.png') : require('../Images/kargoe-watermark.png'),  // 750x270 currently
          X: 0, // mainw - markerWidth * markerScale, // left
          Y: 0, // mainh - markerHeight * markerScale, // top
          scale: 1, // scale of bg
          markerScale: markerScale, // scale of icon
          quality: 100 // quality of image
      }).then((path) => {
          // this is working now
          console.log("watermarked image is " + path)
          if (charity) { // add charity name and possibly icon on bottom of image, start w/ name
            let extraScale = width > 320 ? 2 : 1
            let fontSize = (36) * mainw/640 * extraScale  // baseline 640 from small SEphone
            // *** this marks the charity name
            //  Let's support CHARITY via the kargoe app
            Marker.markText({
              src: 'file://' + path,
              text: hideTags ? '' : "Let's support " + charity.CharityName + " via the kargoe app" + '   ',
              position: 'bottomRight',
              color: '#ffffff',
              fontName: 'Avenir-Black',
              fontSize: fontSize,
              shadowStyle: {
                dx: 0,
                dy: 0,
                radius: 20,
                color: '#000000'
              },
              scale: 1,
              quality: 100
            }).then((path) => {

              console.log("text marked image is " + path)

              const toSend = pathNotUrl ? path : ('file://' + path)
              if (afterMarkingFn) afterMarkingFn(toSend)

            }) // .then of markText

          }
          else {

            const toSend = pathNotUrl ? path : ('file://' + path)
            if (afterMarkingFn) afterMarkingFn(toSend)

            /* something weird going on w/ android see doc for Marker
            this.setState({
                uri: Platform.OS === 'android' ? 'file://' + path : path,
            })
            */

          }
      }).catch((err) => {
          console.log('error marking image with watermark ' + JSON.stringify(err))
      })
    }
  }

var MD5 = function(d){result = M(V(Y(X(d),8*d.length)));return result.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}

export function makeCacheUrl(url, sizing) {
	var bucket  = 'media.kargoe.com';
  var seed    = 'kargoe-=-2019';
	var seconds = Math.round(Date.now() / (5*60000)); // try 5 min so not as many re-pulls from server
	var access  = MD5(url + sizing + seed + seconds);
	var url     = encodeURIComponent(url.replace('://', '/')).replace(/%2F/gi, '/');
	return 'http://' + bucket + '/' + sizing + '/' + url + '?a=' + access + '&t=' + seconds; // cannot use s3.amazon.com/domain and still have virtual website in a bucket.  $600/mo for bucket cert.
}

export function deepClone(variable) {
  if (typeof variable == 'undefined')
    return variable
  return JSON.parse(JSON.stringify(variable))
}

// pass in kargoe standard auth object
// orig example of this in edit post screen when making a live post
// now we make it more generic so anyone can easily view live posts
export function makeSureUserHasAgoraToken(auth) {

  console.log("utils: make sure user has agora token")

    if (auth && auth.user && auth.user.Username) {

      // hack microservice to generate tokens and store on an s3 bucket

      let fetchUrl = 'https://agorakargoe.herokuapp.com/?username=' + auth.user.Username

      fetch(fetchUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }).then(response => {
          console.log("generate token response " + JSON.stringify(response))
          if (response) {
            response.json().then(x => {
              console.log("gen token json response " + JSON.stringify(x))
            })
          }
      }).catch(x => {
        Alert.alert(
          "Error",
          "Caution, cannot generate a live stream token for this user, live streaming may not work.",
          [
            { text: "OK", onPress: () => console.log("OK Pressed") }
          ]
        );
      })

  }

  return true // just so we know it has been called, above happens async

}

export function urlToMediaId(url) {
  if (url == '__DEFAULT__')
      return 10
  if (url.trim() == 0)
      return -1
  const parts = url.split('-myshop.')
  if (parts.length != 2)
      return -1
  let start = parts[0]
  const pos = start.lastIndexOf('-')
  if (pos < 1)
      return -1
  return start.substr(pos+1)
}

export function urlIsJpeg(url) {
  return url.indexOf('.jpg') > 0
}

export function consolidateMediaUrls(list) {
  let details = []
  for (let i = 0; i < list.length; i++) {
      url = list[i]
      const mediaId = urlToMediaId(url)
      const isJpeg = url == '__DEFAULT__' || urlIsJpeg(url)
      let found = false
      for (j = 0; j < details.length; j++)
          if (details[j].mediaId == mediaId) {
              found = true
              if (isJpeg)
                  details[j].imageUrl = url;
              else
                  details[j].videoUrl = url;
          }
      if (!found) {
          let entry = {mediaId}
          if (isJpeg)
              entry.imageUrl = url;
          else
              entry.videoUrl = url;
          details.push(entry)
      }
  }
  return details
}

